'use strict';

export { createAnimatedComponent } from "./createAnimatedComponent.js";
export { NativeEventsManager } from "./NativeEventsManager.js";
//# sourceMappingURL=index.js.map